import React, { Component } from 'react';
import { connect } from "react-redux";
import {
    setContextualHelp,
    setSelectorMode,
    setSidebarViewMode
} from 'actions/index.js';
import {
    ADD_SOUNDS_BUTTON,
    ADD_INSTRUMENTS_BUTTON,
    ADD_PRESETS_BUTTON,
    ADD_SEQUENCES_BUTTON} from 'constants/contextual-help.js';
import {
    SOUNDS,
    EXTERNAL,
    SEQUENCES,
    PRESETS,
    PACKS,
    INSTRUMENTS,
    NOTES} from 'constants/sidebar-view-modes.js';

class OptionTabs extends Component {
    constructor(props) {
        super(props);

        this.onClickOption = this.onClickOption.bind(this);
        this.clear = this.clear.bind(this);
    }

    clear() {
        this.props.setSelectorMode(false);
        this.props.setSidebarViewMode(SOUNDS);
    }

    onClickOption(option) {
        this.clear();
        if (option === SOUNDS) {
            this.props.setSelectorMode(true);
        } 

        this.props.setSidebarViewMode(option);
    }

    getSelectedOption() {
        return this.props.sidebarViewMode;
    }

    render() {
        let selectedOption = this.getSelectedOption();
        return (
            <div className="option-tabs">
              <OptionTab
                onMouseOver={() => this.props.setContextualHelp(ADD_SOUNDS_BUTTON)}
                onMouseLeave={() => this.props.setContextualHelp(undefined)}
                onClear={this.clear}
                onClick={this.onClickOption}
                hideUnderline={this.props.hideUnderline}
                option={SOUNDS}
                selectedOption={selectedOption === SOUNDS && this.props.showSelectorMode ? SOUNDS : undefined}
                name="SOUNDS"/>
              <OptionTab
                onMouseOver={() => this.props.setContextualHelp(ADD_INSTRUMENTS_BUTTON)}
                onMouseLeave={() => this.props.setContextualHelp(undefined)}
                onClear={this.clear}
                onClick={this.onClickOption}
                hideUnderline={this.props.hideUnderline}
                option={INSTRUMENTS} selectedOption={selectedOption} name="INSTRUMENTS"/>
            <OptionTab
                onMouseOver={() => this.props.setContextualHelp(ADD_SEQUENCES_BUTTON)}
                onMouseLeave={() => this.props.setContextualHelp(undefined)}
                onClear={this.clear}
                onClick={this.onClickOption}
                hideUnderline={this.props.hideUnderline}
                option={SEQUENCES} selectedOption={selectedOption} name="PROJECTS"/>
            <OptionTab
                onMouseOver={() => this.props.setContextualHelp(ADD_SEQUENCES_BUTTON)}
                onMouseLeave={() => this.props.setContextualHelp(undefined)}
                onClear={this.clear}
                onClick={this.onClickOption}
                hideUnderline={this.props.hideUnderline}
                option={PACKS} selectedOption={selectedOption} name="PACKS"/>
            </div>
        );
    }
}

class OptionTab extends Component {
    isSelected() {
        return this.props.selectedOption ===
            this.props.option;
    }

    onClick() {
        if (this.isSelected()) {
            this.props.onClear();
        } else {
            this.props.onClick(this.props.option);
        }
    }
    render() {
        return (
            <div
              onMouseOver={this.props.onMouseOver}
              onMouseLeave={this.props.onMouseLeave}
              onClick={() => this.onClick()}
              className={this.isSelected() ? "option-tab selected" : "option-tab"}>
              {this.props.name}
              {this.isSelected() && !this.props.hideUnderline ? <div className="option-tab-underline"/> : ''}
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setSelectorMode: m => dispatch(setSelectorMode(m)),
        setSidebarViewMode: m => dispatch(setSidebarViewMode(m)),
        setContextualHelp: m => dispatch(setContextualHelp(m)),
    };
};

const mapStateToProps = state => {
    return {
        showSelectorMode: state.sequencer.showSelectorMode,
        sidebarViewMode: state.sequencer.sidebarViewMode,
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(OptionTabs);
